import { addNewBlock } from '../utils/add-new-block';
import { convert } from '../utils/convert';
import { AnalogInput, AnalogTemperatureSensor, BoilerAdapter, Buzzer, BuzzerState, GuardZone, GuardZoneState, HeatingCircuit, Pump, PumpState, RadioSensor, RadioSensor433, RelayControl, RelayControlState, Sensor433State, SensorState, ThreewayTap, ThreewayTapState, WiredTemperatureSensor, } from 'z3k-config';
import { FixedBlockType } from '../types/block-type';
import { buzzerStateTranslate, guardZoneStateTranslate, pumpStateTranslate, relayControlStateTranslate, sensor433StateTranslate, sensorStateTranslate, threewayTapStateTranslate, } from '../utils/translates';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
function addSensorBlockDefinition(name, options, color_of_state_blocks, lineBreakAfterName) {
    return {
        message0: lineBreakAfterName ? `${name} %1 %2 %3` : `${name} %1 %2`,
        args0: [
            ...(lineBreakAfterName
                ? [
                    {
                        type: 'input_dummy',
                    },
                ]
                : []),
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        sensorStateTranslate[SensorState.OFFLINE],
                        SensorState.OFFLINE.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.OUT_OF_UPPER_THRESHOLD],
                        SensorState.OUT_OF_UPPER_THRESHOLD.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.OUT_OF_LOWER_THRESHOLD],
                        SensorState.OUT_OF_LOWER_THRESHOLD.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.ACTUATION],
                        SensorState.ACTUATION.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.RECOVERY],
                        SensorState.RECOVERY.toString(),
                    ],
                ],
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    };
}
function addBoilerAdapterBlockDefinition(name, options, color_of_state_blocks, lineBreakAfterName) {
    return {
        message0: lineBreakAfterName ? `${name} %1 %2 %3` : `${name} %1 %2`,
        args0: [
            ...(lineBreakAfterName
                ? [
                    {
                        type: 'input_dummy',
                    },
                ]
                : []),
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    ['Потеря связи с котлом', SensorState.OFFLINE.toString()],
                    [
                        'Восстановление связи с котлом',
                        SensorState.OUT_OF_UPPER_THRESHOLD.toString(),
                    ],
                    ['Авария ктола', SensorState.OUT_OF_LOWER_THRESHOLD.toString()],
                    ['Устранение аварии котла', SensorState.ACTUATION.toString()],
                ],
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    };
}
function addAnalogTemperatureSensorStateBlock(color_of_state_blocks, config) {
    const options = convert(AnalogTemperatureSensor.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block_type = FixedBlockType.analog_temperature_sensor_state;
    addNewBlock(block_type, addSensorBlockDefinition('NTC Датчик', options, color_of_state_blocks, false));
    return block_type;
}
function addAnalogInputStateBlock(color_of_state_blocks, config) {
    const options = convert(AnalogInput.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block_type = FixedBlockType.analog_input_state;
    addNewBlock(block_type, addSensorBlockDefinition('Датчик', options, color_of_state_blocks, true));
    return block_type;
}
function addHeatingModeForHeatingCircuitStateBlock(color_of_state_blocks, config) {
    const heating_circuit_options = convert(HeatingCircuit.get.all(config));
    const heating_mode_options = convert(HeatingMode.get.all(config));
    if (heating_circuit_options.length === 0 || heating_mode_options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Режим %3 в контуре %2 %1',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options: heating_circuit_options,
            },
            {
                type: 'input_dummy',
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: heating_mode_options,
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    };
    const block_type = FixedBlockType.state_heat_mode_for_heat_circuit;
    addNewBlock(block_type, block);
    return block_type;
}
function addPumpStateBlock(color_of_state_blocks, config) {
    const options = convert(Pump.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Насос %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [pumpStateTranslate[PumpState.ON], PumpState.ON.toString()],
                    [pumpStateTranslate[PumpState.OFF], PumpState.OFF.toString()],
                ],
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    };
    const block_type = FixedBlockType.pump_state;
    addNewBlock(block_type, block);
    return block_type;
}
function addRadioSensorStateBlock(color_of_state_blocks, config) {
    //Потому что у датчиков влажности есть дополнительные параметры в аргументах,
    // они уезжают в отдельный блок
    const sensors_without_humidity = RadioSensor.get.where(config, (sensor) => sensor.type !== RadioSensor.Type.HUMIDITY);
    const options = convert(sensors_without_humidity);
    if (options.length === 0) {
        return null;
    }
    const block_type = FixedBlockType.radio_sensor_state;
    addNewBlock(block_type, addSensorBlockDefinition('Радиодатчик', options, color_of_state_blocks, false));
    return block_type;
}
function addHumidityRadioSensorStateBlock(color_of_state_blocks, config) {
    const humidity_sensors = RadioSensor.get.where(config, (sensor) => sensor.type === RadioSensor.Type.HUMIDITY);
    const options = convert(humidity_sensors);
    if (options.length === 0) {
        return null;
    }
    const block_type = FixedBlockType.humidity_radio_sensor_state;
    addNewBlock(block_type, {
        message0: 'Радиодатчик влажности %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        sensorStateTranslate[SensorState.OFFLINE],
                        SensorState.OFFLINE.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.OUT_OF_UPPER_THRESHOLD],
                        SensorState.OUT_OF_UPPER_THRESHOLD.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.OUT_OF_LOWER_THRESHOLD],
                        SensorState.OUT_OF_LOWER_THRESHOLD.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.ACTUATION],
                        SensorState.ACTUATION.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.RECOVERY],
                        SensorState.RECOVERY.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.OUT_OF_UPPER_HUMIDITY_THRESHOLD],
                        SensorState.OUT_OF_UPPER_HUMIDITY_THRESHOLD.toString(),
                    ],
                    [
                        sensorStateTranslate[SensorState.OUT_OF_LOWER_HUMIDITY_THRESHOLD],
                        SensorState.OUT_OF_LOWER_HUMIDITY_THRESHOLD.toString(),
                    ],
                ],
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    });
    return block_type;
}
function addRadioSensor433StateBlock(color_of_state_blocks, config) {
    const options = convert(RadioSensor433.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Радиодатчик-433 %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        sensor433StateTranslate[Sensor433State.OFFLINE],
                        Sensor433State.OFFLINE.toString(),
                    ],
                    [
                        sensor433StateTranslate[Sensor433State.TRIGGERED],
                        Sensor433State.TRIGGERED.toString(),
                    ],
                ],
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    };
    const block_type = FixedBlockType.radio_sensor_433_state;
    addNewBlock(block_type, block);
    return block_type;
}
function addRelayStateBlock(color_of_state_blocks, config) {
    const options = convert(RelayControl.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Реле %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        relayControlStateTranslate[RelayControlState.ON],
                        RelayControlState.ON.toString(),
                    ],
                    [
                        relayControlStateTranslate[RelayControlState.OFF],
                        RelayControlState.OFF.toString(),
                    ],
                ],
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    };
    const block_type = FixedBlockType.relay_state;
    addNewBlock(block_type, block);
    return block_type;
}
function addGuardStateBlock(color_of_state_blocks, config) {
    const options = convert(GuardZone.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Охранная зона %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        guardZoneStateTranslate[GuardZoneState.GUARD_ON],
                        GuardZoneState.GUARD_ON.toString(),
                    ],
                    [
                        guardZoneStateTranslate[GuardZoneState.GUARD_OFF],
                        GuardZoneState.GUARD_OFF.toString(),
                    ],
                    [
                        guardZoneStateTranslate[GuardZoneState.ALARM],
                        GuardZoneState.ALARM.toString(),
                    ],
                ],
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    };
    const block_type = FixedBlockType.guard_state;
    addNewBlock(block_type, block);
    return block_type;
}
function addBuzzerStateBlock(color_of_state_blocks, config) {
    const options = convert(Buzzer.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: '%1 %2 %3',
        args0: [
            {
                type: 'field_label_serializable',
                name: 'siren',
                text: 'Сирена',
            },
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [buzzerStateTranslate[BuzzerState.ON], BuzzerState.ON.toString()],
                    [buzzerStateTranslate[BuzzerState.OFF], BuzzerState.OFF.toString()],
                ],
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    };
    const block_type = FixedBlockType.buzzer_state;
    addNewBlock(block_type, block);
    return block_type;
}
function addTapStateBlock(color_of_state_blocks, config) {
    const options = convert(ThreewayTap.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block = {
        message0: 'Сервопривод %1 %2',
        args0: [
            {
                type: 'field_dropdown',
                name: 'id',
                options,
            },
            {
                type: 'field_dropdown',
                name: 'argument',
                options: [
                    [
                        threewayTapStateTranslate[ThreewayTapState.AT_REST],
                        ThreewayTapState.AT_REST.toString(),
                    ],
                    [
                        threewayTapStateTranslate[ThreewayTapState.OPENING],
                        ThreewayTapState.OPENING.toString(),
                    ],
                    [
                        threewayTapStateTranslate[ThreewayTapState.CLOSING],
                        ThreewayTapState.CLOSING.toString(),
                    ],
                    [
                        threewayTapStateTranslate[ThreewayTapState.OPEN],
                        ThreewayTapState.OPEN.toString(),
                    ],
                    [
                        threewayTapStateTranslate[ThreewayTapState.CLOSE],
                        ThreewayTapState.CLOSE.toString(),
                    ],
                ],
            },
        ],
        output: 'Boolean',
        tooltip: '',
        helpUrl: '',
        colour: color_of_state_blocks,
    };
    const block_type = FixedBlockType.tap_state;
    addNewBlock(block_type, block);
    return block_type;
}
function addWiredTemperatureSensorStateBlock(color_of_state_blocks, config) {
    const options = convert(WiredTemperatureSensor.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block_type = FixedBlockType.wired_temperature_sensor_state;
    addNewBlock(block_type, addSensorBlockDefinition('Проводной датчик температуры', options, color_of_state_blocks, true));
    return block_type;
}
function addBoilerAdapterState(color_of_state_blocks, config) {
    if (Number(config.device.firmware) <= 309) {
        return null;
    }
    const options = convert(BoilerAdapter.get.all(config));
    if (options.length === 0) {
        return null;
    }
    const block_type = FixedBlockType.boiler_adapter;
    addNewBlock(block_type, addBoilerAdapterBlockDefinition('Адаптеры котлов', options, color_of_state_blocks, true));
    return block_type;
}
export function generateStateBlocks(color_of_logic_blocks, config) {
    return [
        addAnalogTemperatureSensorStateBlock,
        addAnalogInputStateBlock,
        addHeatingModeForHeatingCircuitStateBlock,
        addPumpStateBlock,
        addRadioSensorStateBlock,
        addHumidityRadioSensorStateBlock,
        addRadioSensor433StateBlock,
        addRelayStateBlock,
        addGuardStateBlock,
        addBuzzerStateBlock,
        addTapStateBlock,
        addWiredTemperatureSensorStateBlock,
        addBoilerAdapterState,
    ]
        .map((func) => func(color_of_logic_blocks, config))
        .filter((item) => item != null);
}
